
import { MainLoginComponent } from "./components/main-login.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'login',
        component: MainLoginComponent,
        //canActivate: [AuthService]
    },
    {
        path: 'new-password/:token',
        component: MainLoginComponent,
        //canActivate: [AuthService]
    },    
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class LoginRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/login/login.routes.ts